<template>
    <a
        v-if="isExternalLink"
        :href="slideLink"
        :target="target"
        rel="noopener noreferrer"
        class="useful-card relative offer-slide"
        :style="backgroundImage(slideImg.src, backgroundModifiers)"
    >
        <div class="useful-card__content relative">
            <div>
                <h4
                    v-if="slideTitle.title"
                    :class="[
                        'useful-card__title',
                        ...(slideTitle?.additionalClasses ?? [])
                    ]"
                    v-html="slideTitle.title"
                />
                <div
                    v-if="slideValue"
                    class="useful-card__descr-wrapp"
                >
                    <p
                        :class="['useful-card__desc', slideValue.classes]"
                        v-html="slideValue.value"
                    />
                </div>
            </div>
            <p class="useful-card__content-link">
                Перейти на сайт
                <svg
                    fill="#494B52"
                    width="20"
                    height="20"
                    viewBox="0 0 50 25"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M38.288 10.297l1.414 1.415-14.99 14.99-1.414-1.414z" />
                    <path d="M40 20h-2v-8h-8v-2h10z" />
                    <!-- eslint-disable-next-line max-len -->
                    <path d="M35 38H15c-1.7 0-3-1.3-3-3V15c0-1.7 1.3-3 3-3h11v2H15c-.6 0-1 .4-1 1v20c0 .6.4 1 1 1h20c.6 0 1-.4 1-1V24h2v11c0 1.7-1.3 3-3 3z" />
                </svg>
            </p>
        </div>
    </a>
    <n-link
        v-else
        :to="slideLink"
        class="useful-card relative offer-slide"
        :style="backgroundImage(slideImg.src, backgroundModifiers)"
    >
        <div class="useful-card__content relative">
            <div>
                <h4
                    v-if="slideTitle.title"
                    :class="[
                        'useful-card__title',
                        ...(slideTitle?.additionalClasses ?? [])
                    ]"
                    v-html="slideTitle.title"
                />
                <div
                    v-if="slideValue"
                    class="useful-card__descr-wrapp"
                >
                    <p
                        :class="['useful-card__desc', slideValue.classes]"
                        v-html="slideValue.value"
                    />
                </div>
            </div>
            <p class="useful-card__content-link">
                Подробнее
                <svg
                    width="5"
                    height="7"
                    viewBox="0 0 5 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M1 0.5L4 3.5L1 6.5"
                        stroke="#494B52"
                    />
                </svg>
            </p>
        </div>
    </n-link>
</template>

<script>
import {computed, defineComponent} from 'vue';

import {useCompressedBackgroundImage} from '@/core/composables/useCompressedBackgroundImage';

export default defineComponent({
    name: 'SlideItem',
    props: {
        slideImg: {
            type: [Object, String],
            required: true,
        },
        slideTitle: {
            type: Object,
            default: () => null,
        },
        slideLink: {
            type: String,
            default: () => '',
        },
        slideValue: {
            type: Object,
            default: () => null,
        },
        slideAddition: {
            type: Object,
            default: () => null,
        },
        mainSlide: {
            type: Boolean,
            default: () => false,
        },
        target: {
            type: String,
            default: () => '_blank',
        },
    },
    setup(props) {
        const {backgroundImage} = useCompressedBackgroundImage();

        const isExternalLink = computed(() => {
            if (!props.slideLink.startsWith('/') || props.slideLink.includes('cabinet')) {
                return true;
            }

            return false;
        });

        return {
            isExternalLink,
            backgroundModifiers: {
                format: 'webp',
                loading: 'lazy',
            },
            backgroundImage,
        };
    },
});
</script>

<style lang="scss">
@import '@/assets/styles/components/home-page/index/useful-card';
</style>
